import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";

import ContentEditData from "modules/ContentEdit/components/contentEditData/ContentEditData";

type Props = {};

const ContentEditContainer = (props: Props) => {

  return (
    <AppLayout>
      <ContentEditData />
    </AppLayout>
  );
};

export default ContentEditContainer;
